import React from 'react';
import styles from '../../styles/ForecastCards.module.scss';
import { ForecastDay } from '../../types/WeatherData';

interface ForecastCardsProps {
  forecastData: ForecastDay[];
}

const ForecastCards: React.FC<ForecastCardsProps> = ({ forecastData }) => {
  return (
    <div className={styles['forecast-container']}>
      {forecastData.slice(0, 3).map((day) => (
        <div key={day.date} className={styles['forecast-card']}>
          <h3>
            {new Date(`${day.date}T00:00`).toLocaleDateString(undefined, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </h3>
          <img
            src={`https:${day.day.condition.icon}`}
            alt={day.day.condition.text}
            className={styles['forecast-icon']}
          />
          <p className={styles['forecast-text']}>{day.day.condition.text}</p>
          <p className={styles['forecast-temp']}>High: {Math.round(day.day.maxtemp_f)}°F</p>
          <p className={styles['forecast-temp']}>Low: {Math.round(day.day.mintemp_f)}°F</p>
        </div>
      ))}
    </div>
  );
};

export default ForecastCards;
